export default __webpack_public_path__ + "static/media/9@3x.99af1d09.png";